import TokenDetails from './TokenDetails'

export default TokenDetails
